.header {
    color: var(--grey-dk);
    font-weight: 500;
    font-size: var(--font-normal);
    line-height: 19px;
    margin-bottom: 4px;
}

.tracking-snippet-page {
    min-width: 600px;
}
